/**
 * Le zoom d'une figure tient dans l'écran (prof 2026-09-25 : « quand on agrandit
 * un SVG, pas de scroll : le voir à sa taille max, tout lisible dans l'écran,
 * fixe ou mobile »).
 *
 * Avant, l'agrandi se dimensionnait par la largeur (w-full, h-auto) dans une
 * boîte à ascenseur : une figure plus haute que large prenait 90 % de la
 * largeur, dépassait la hauteur, et il fallait scroller. Ici la boîte prend la
 * plus grande taille qui tienne À LA FOIS en largeur et en hauteur, en gardant
 * les proportions : `width: min(largeur dispo, hauteur dispo × rapport)` et
 * `aspect-ratio`. Le média la remplit (w-full h-full, object-contain).
 *
 * Le rapport largeur / hauteur vient du viewBox du SVG (sinon de ses attributs
 * width / height), ou des dimensions naturelles d'une image une fois chargée.
 */

/** Rapport largeur / hauteur d'un SVG (texte) : viewBox, sinon width / height ; null si inconnu. */
export const ratioSvg = (svg) => {
    const s = String(svg || '');
    const vb = /viewBox\s*=\s*["']\s*[-\d.]+[\s,]+[-\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+)\s*["']/i.exec(s);
    if (vb && Number(vb[2]) > 0) return Number(vb[1]) / Number(vb[2]);
    const tag = /<svg[^>]*>/i.exec(s); if (!tag) return null;
    const w = /\swidth\s*=\s*["']([\d.]+)/i.exec(tag[0]); const h = /\sheight\s*=\s*["']([\d.]+)/i.exec(tag[0]);
    return w && h && Number(h[1]) > 0 ? Number(w[1]) / Number(h[1]) : null;
};

/** Le SVG d'une data-URL (`data:image/svg+xml,…`), décodé ; null pour tout autre src. */
export const svgDeDataUrl = (src) => {
    const s = String(src || '');
    if (!s.startsWith('data:image/svg+xml')) return null;
    const virgule = s.indexOf(','); if (virgule < 0) return null;
    const corps = s.slice(virgule + 1);
    try { return /;base64/i.test(s.slice(0, virgule)) ? atob(corps) : decodeURIComponent(corps); } catch { return null; }
};

/**
 * Un SVG sans viewBox mais avec width / height ne se met pas à l'échelle : on
 * lui en donne un (0 0 width height). Les SVG des générateurs en ont déjà un.
 */
export const avecViewBox = (svg) => {
    const s = String(svg || '');
    const tag = /<svg[^>]*>/i.exec(s); if (!tag || /viewBox\s*=/i.test(tag[0])) return s;
    const w = /\swidth\s*=\s*["']([\d.]+)/i.exec(tag[0]); const h = /\sheight\s*=\s*["']([\d.]+)/i.exec(tag[0]);
    if (!w || !h) return s;
    return s.replace(tag[0], tag[0].replace(/<svg/i, `<svg viewBox="0 0 ${w[1]} ${h[1]}"`));
};

/**
 * Le style de la boîte agrandie : la plus grande taille qui tient dans
 * `largeur` × `hauteur` (en vw / vh) en gardant `ratio` (largeur / hauteur).
 * Sans rapport connu : une boîte bornée, sans ascenseur.
 */
export const styleAjuste = (ratio, { largeur = 92, hauteur = 86 } = {}) => {
    if (!ratio || !Number.isFinite(ratio) || ratio <= 0) return { maxWidth: `${largeur}vw`, maxHeight: `${hauteur}vh` };
    return { width: `min(${largeur}vw, calc(${hauteur}vh * ${ratio}))`, aspectRatio: String(ratio) };
};
